import { render, staticRenderFns } from "./DomainWorkspaceToolbar.vue?vue&type=template&id=04610bb6&"
import script from "./DomainWorkspaceToolbar.vue?vue&type=script&lang=ts&"
export * from "./DomainWorkspaceToolbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VIcon,VSpacer,VToolbar,VToolbarTitle})


/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04610bb6')) {
      api.createRecord('04610bb6', component.options)
    } else {
      api.reload('04610bb6', component.options)
    }
    module.hot.accept("./DomainWorkspaceToolbar.vue?vue&type=template&id=04610bb6&", function () {
      api.rerender('04610bb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/navigation/DomainWorkspaceToolbar.vue"
export default component.exports